// store constants
// values should be camelCased please
// please keep alphabetized
export const ALERTS = 'alerts';
export const AUTH = 'auth';
export const CUSTOMER_PERMISSIONS = 'customerPermissions';
export const ERRORS = 'errors';
export const FEATURE_USER_SETTINGS = 'featureUserSettings';
export const FEATURES = 'features';
export const FILL_ADVISOR_DATA = 'fillAdvisorData';
export const IMAGE_UPLOAD = 'imageUpload';
export const JOB_FORM_ACTIVE_SECTION = 'jobFormActiveSection';
export const JOB_FORM_VALID_SECTIONS = 'jobFormValidSections';
export const LOADING = 'loading';
export const MAGIC_ALGORITHM = 'magicAlgorithm';
export const PAGING = 'pagination';
export const POST_MESSAGE = 'postMessage';
export const REQUIREMENTS_TAGS = 'requirementsTags';
export const SORT = 'sort';
export const TEMPLATES = 'templates';
export const THEME = 'theme';
export const TRYOUT_BADGES = 'tryoutBadges';
export const USER = 'user';
export const BROWSER_STORAGE = 'browserStorage';
export const MESSAGES_PAGE = 'MESSAGES_PAGE';
export const WANDAS_PAGE = 'WANDAS_PAGE';
export const SIMPLIFIED_JOB_POSTING = 'SIMPLIFIED_JOB_POSTING';
export const PREFERRED_MODAL = 'PREFERRED_MODAL';
